import {message} from "antd";

/**
 * 网上缴费支付支付跳转 for 临沂
 */
export const handle = (csxx, xsxx) => {

    console.log('csxx', csxx)
    console.log('xsxx', xsxx)

    let url = csxx.pczflj;//单点登录连接地址
    if (!url) {
        message.info("支付路径不能为空，请联系管理员！");
        return;
    }
    let sfzjh = xsxx.SFZJH;
    if (!sfzjh) {
        message.info("学生身份证号不能为空，请联系管理员！");
        return;
    }
    let xm = xsxx.XM;
    if (!xm) {
        message.info("学生姓名不能为空，请联系管理员！");
        return;
    }

    let tm = getNowFormatDate();
    // 对中文参数进行转义处理
    window.open(`${url}?xm=${encodeURIComponent(xm)}&sfzjh=${encodeURIComponent(sfzjh)}&time=${encodeURIComponent(tm)}`, "_blank");
}


// 获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let hours = date.getHours(); //获取系统时，
    let minutes = date.getMinutes(); //分
    let seconds = date.getSeconds(); //秒
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
    }
    return year + month + strDate + hours + minutes + seconds;
}
